import { useContext } from 'react'
import { translate } from '../../../utils/translation'
import { FidelityContext } from '../../../context/FidelityContext'

export const useFilter = () => {
  const {
    filterCampaignEnums,
    getCurrentCampaignFilter,
    handleChangeCampaignFilter,
  } = useContext(FidelityContext)

  const filterCollection = [
    {
      key: `statement-filter-${filterCampaignEnums['all-campaign']}`,
      value: filterCampaignEnums['all-campaign'],
      name: 'Todas as campanhas',
    },
    {
      key: `statement-filter-${filterCampaignEnums['my-campaign']}`,
      value: filterCampaignEnums['my-campaign'],
      name: 'Minhas campanhas',
    },
    {
      key: `statement-filter-${filterCampaignEnums['active-campaign']}`,
      value: filterCampaignEnums['active-campaign'],
      name: 'Campanhas ativas',
    },
    {
      key: `statement-filter-${filterCampaignEnums['closed-campaign']}`,
      value: filterCampaignEnums['closed-campaign'],
      name: 'Campanhas encerradas',
    },
  ]
  const handleFilterRowClick = ({ value }) => {
    handleChangeCampaignFilter(value)
  }
  const getActiveFilter = ({ value }) => {
    if (value !== getCurrentCampaignFilter()) return false
    return true
  }
  const getTranslate = ({ name }) => {
    return translate(name)
  }
  return {
    filterCollection,
    getTranslate,
    getActiveFilter,
    handleFilterRowClick,
  }
}
